import { Dispatch, SetStateAction } from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import info from '../../../../assets/images/icons/info.svg';
import { CustomStyle } from '../../../../components/CustomSelectStyle';
import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../../components/FormGroup';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import { ConditionalInputGroup, Container, Group } from '../styles';
import { PartnerType, TechnologyType } from '../types';

interface ApiIntegrationsSettingsTabI {
  willIntegrateWithPayroll: boolean;
  setWillIntegrateWithPayroll: Dispatch<SetStateAction<boolean>>;
  technology: TechnologyType;
  setTechnology: Dispatch<SetStateAction<TechnologyType>>;
  technologyOptions: TechnologyType[];
  hasWebhook: boolean;
  setHasWebhook: Dispatch<SetStateAction<boolean>>;
  hasResultReadyWebhook: boolean;
  setHasResultReadyWebhook: Dispatch<SetStateAction<boolean>>;
  hasResultOutOfScopeWebhook: boolean;
  setHasResultOutOfScopeWebhook: Dispatch<SetStateAction<boolean>>;
  integrator: PartnerType;
  setIntegrator: Dispatch<SetStateAction<PartnerType>>;
  partnerOptions: PartnerType[];
}

export default function ApiIntegrationsSettingsTab({
  willIntegrateWithPayroll,
  setWillIntegrateWithPayroll,
  technology,
  setTechnology,
  technologyOptions,
  hasWebhook,
  setHasWebhook,
  hasResultReadyWebhook,
  setHasResultReadyWebhook,
  hasResultOutOfScopeWebhook,
  setHasResultOutOfScopeWebhook,
  integrator,
  setIntegrator,
  partnerOptions,
}: ApiIntegrationsSettingsTabI) {
  return (
    <Row xs={1} md={1} lg={1}>
      <Col>
        <Container>
          <div className="card-title">
            Integrações API
          </div>
          <Group>
            <div className="title">
              <div>
                Integração dos implantados para a Folha de Pagamento?
                {' '}
                <img src={info} alt="info" title="Habilitar esta opção fará que uma pessoa perca a titularidade caso deixe de embarcar em uma linha com a frequência desejada. Quando ativada, o sistema verificará se o colaborador está deixando de utilizar uma linha de fretamento com a frequência desejada, e irá retirar a titularidade dele na mesma, liberando a vaga para outra pessoa que deseja utilizá-la." />
              </div>
            </div>
            <ConditionalInputGroup>
              <FilterRadioButtonsContainer notOverflow>
                <FilterRadioButton
                  selected={willIntegrateWithPayroll}
                  onClick={() => setWillIntegrateWithPayroll(true)}
                >
                  Sim
                </FilterRadioButton>
                <FilterRadioButton
                  selected={!willIntegrateWithPayroll}
                  onClick={() => setWillIntegrateWithPayroll(false)}
                >
                  Não
                </FilterRadioButton>
              </FilterRadioButtonsContainer>

              {willIntegrateWithPayroll && (
                <OpacityAnimation>
                  <FormGroup /*error={getErrorMessageByFieldName('email')}*/>
                    <label htmlFor="daysOfHolder">Tecnologia</label>
                    <Select
                      value={technology}
                      options={technologyOptions}
                      onChange={(opt) => {
                        setTechnology(opt!);
                      }}
                      placeholder="Selecione uma tecnologia"
                      styles={CustomStyle}
                      classNamePrefix="react-select"
                      className="react-select-container"
                    />
                  </FormGroup>
                </OpacityAnimation>
              )}
            </ConditionalInputGroup>
          </Group>

          <Group>
            <div className="title">
              <div>
            Integrador
                {' '}
                <img src={info} alt="info" title="Se o integrador for algum diferente do setado no parceiro, especifique qual o integrador aqui." />
              </div>
            </div>
            <Select
              value={integrator}
              options={partnerOptions}
              onChange={(partnerOpt) => {
                setIntegrator(partnerOpt!);
              }}
              placeholder="Nenhum parceiro"
              styles={CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
            />
          </Group>

          <Group>
            <div className="title">
              <div>
                É notificado via webhook quando o resultado de uma roteirização é finalizado?
                {' '}
                <img src={info} alt="info" title="Quando ativada, o sistema notificará via webhook quando o processamento de uma roteirização é finalizado, de acordo com a configuração do webhook do parceiro a que ela está associada. Essa opção irá mesclar o webhook com o web consulta." />
              </div>
            </div>
            <FilterRadioButtonsContainer notOverflow>
              <FilterRadioButton
                selected={hasResultReadyWebhook}
                onClick={() => {
                  setHasResultReadyWebhook(true);
                  setHasResultOutOfScopeWebhook(false);}}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!hasResultReadyWebhook}
                onClick={() => setHasResultReadyWebhook(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          {!hasResultReadyWebhook && (
            <Group>
              <div className="title">
                <div>
                  É notificado via webhook quando o resultado de uma roteirização é fora de abrangência?
                  {' '}
                  <img src={info} alt="info" title="Quando ativada, o sistema notificará via webhook somente quando o resultado de uma roteirização é finalizado com o status de fora de abrangência de acordo com a configuração do webhook do parceiro a que ela está associada. Essa opção irá mesclar o webhook com o web consulta." />
                </div>
              </div>
              <FilterRadioButtonsContainer notOverflow>
                <FilterRadioButton
                  selected={hasResultOutOfScopeWebhook}
                  onClick={() => setHasResultOutOfScopeWebhook(true)}
                >
                    Sim
                </FilterRadioButton>
                <FilterRadioButton
                  selected={!hasResultOutOfScopeWebhook}
                  onClick={() => setHasResultOutOfScopeWebhook(false)}
                >
                    Não
                </FilterRadioButton>
              </FilterRadioButtonsContainer>
            </Group>
          )}

          <Group>
            <div className="title">
              <div>
                É notificado via webhook quando uma reclamação é respondida?
                {' '}
                <img src={info} alt="info" title="Quando ativada, o sistema notificará via webhook quando uma reclamação é respondida, de acordo com a configuração do webhook do parceiro a que ela está associada. Essa opção irá mesclar o webhook com o web consulta." />
              </div>
            </div>
            <FilterRadioButtonsContainer notOverflow>
              <FilterRadioButton
                selected={hasWebhook}
                onClick={() => setHasWebhook(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!hasWebhook}
                onClick={() => setHasWebhook(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>
        </Container>
      </Col>
    </Row>
  );
}
